import type {
  HeroSlide, BenefitItem, PromoCTAData,
  FeaturedProduct, GreenBannerPoint, NewsItem,
} from '../model/types'

export const HERO_SLIDES: HeroSlide[] = [
  {
    id: 'slide-1',
    title: 'Xe Điện Hiện Đại',
    subtitle: 'Di Chuyển Thông Minh',
    tagline: 'Tiết kiệm năng lượng — Bảo vệ môi trường',
    ctaLabel: 'Mua ngay',
    ctaTo: '/danh-muc/xe-may-dien',
    image: 'https://images.unsplash.com/photo-1558981806-ec527fa84c39?w=1200&q=80',
    features: [
      { label: 'Tiết kiệm\nchi phí', icon: 'leaf', color: 'text-accent-500' },
      { label: 'An toàn\nvượt trội', icon: 'shield-check', color: 'text-accent-500' },
      { label: 'Thân thiện\nmôi trường', icon: 'plug', color: 'text-accent-500' },
    ],
  },
  {
    id: 'slide-2',
    title: 'Xe Đạp Điện',
    subtitle: 'Cho Học Sinh Sinh Viên',
    tagline: 'Pin bền — Nhẹ nhàng — An toàn tuyệt đối',
    ctaLabel: 'Khám phá',
    ctaTo: '/danh-muc/xe-dap-dien',
    image: 'https://images.unsplash.com/photo-1571068316344-75bc76f77890?w=1200&q=80',
    features: [
      { label: 'Pin\nLithium', icon: 'battery-charging', color: 'text-accent-500' },
      { label: 'Nhẹ &\nBền', icon: 'shield-check', color: 'text-accent-500' },
      { label: 'Giá\nhợp lý', icon: 'leaf', color: 'text-accent-500' },
    ],
  },
  {
    id: 'slide-3',
    title: 'Khuyến Mãi Tháng 11',
    subtitle: 'Giảm Đến 2.000.000đ',
    tagline: 'Áp dụng cho các dòng xe máy điện cao cấp',
    ctaLabel: 'Xem ưu đãi',
    ctaTo: '/khuyen-mai',
    image: 'https://images.unsplash.com/photo-1609630875171-b1321377ee65?w=1200&q=80',
    features: [
      { label: 'Trả góp\n0%', icon: 'leaf', color: 'text-accent-500' },
      { label: 'Tặng\nmũ BH', icon: 'shield-check', color: 'text-accent-500' },
      { label: 'Bảo hành\n3 năm', icon: 'plug', color: 'text-accent-500' },
    ],
  },
]

export const BENEFITS: BenefitItem[] = [
  { label: 'Sản phẩm chính hãng', highlight: '100%', icon: 'award' },
  { label: 'Giao hàng nhanh', highlight: 'Toàn quốc', icon: 'truck' },
  { label: 'Bảo hành dài hạn', highlight: '3 năm', icon: 'shield-check' },
  { label: 'Hỗ trợ kỹ thuật', highlight: '24/7', icon: 'headphones' },
]

export const PROMO_CTA: PromoCTAData = {
  title: 'Ưu Đãi Hấp Dẫn',
  highlight: 'Giảm đến\n2.000.000đ',
  ctaLabel: 'Xem ngay',
  ctaTo: '/khuyen-mai',
}

export const HERO_AUTOPLAY_MS = 6000

export const FEATURED_PRODUCTS: FeaturedProduct[] = [
  {
    id: 'p1', slug: 'xe-may-dien-alpha-s', name: 'Xe máy điện Alpha S',
    price: 17010000, oldPrice: 18990000, discountPct: 10,
    image: 'https://images.unsplash.com/photo-1609630875171-b1321377ee65?w=600&q=80',
    rating: 4.5, reviews: 125,
  },
  {
    id: 'p2', slug: 'xe-may-dien-zoomer-x', name: 'Xe máy điện Zoomer X',
    price: 18450000, oldPrice: 20500000, discountPct: 10,
    image: 'https://images.unsplash.com/photo-1558981806-ec527fa84c39?w=600&q=80',
    rating: 4.5, reviews: 98,
  },
  {
    id: 'p3', slug: 'xe-dap-dien-cute-20', name: 'Xe đạp điện Cute 20 inch',
    price: 13410000, oldPrice: 14900000, discountPct: 10,
    image: 'https://images.unsplash.com/photo-1571068316344-75bc76f77890?w=600&q=80',
    rating: 4.5, reviews: 87,
  },
  {
    id: 'p4', slug: 'xe-dap-dien-sport-pro', name: 'Xe đạp điện Sport Pro',
    price: 15210000, oldPrice: 16900000, discountPct: 10,
    image: 'https://images.unsplash.com/photo-1532298229144-0ec0c57515c7?w=600&q=80',
    rating: 4.5, reviews: 110,
  },
  {
    id: 'p5', slug: 'xe-may-dien-feliz-neo', name: 'Xe máy điện Feliz Neo',
    price: 17910000, oldPrice: 18900000, discountPct: 10,
    image: 'https://images.unsplash.com/photo-1619771914272-e3c1ba17ba4d?w=600&q=80',
    rating: 4.5, reviews: 72,
  },
]

export const GREEN_BANNER_POINTS: GreenBannerPoint[] = [
  { label: 'Không khói bụi' },
  { label: 'Tiết kiệm chi phí' },
  { label: 'Bảo vệ môi trường' },
]

export const NEWS_ITEMS: NewsItem[] = [
  {
    id: 'n1',
    title: 'Top 5 xe máy điện bán chạy nhất 2026',
    excerpt: 'Điểm mặt 5 mẫu xe máy điện được khách Việt tin dùng nhất nửa đầu năm 2026…',
    image: 'https://images.unsplash.com/photo-1558981806-ec527fa84c39?w=800&q=80',
    date: '02/11/2026',
    to: '/tin-tuc/top-5-xe-may-dien-2026',
  },
  {
    id: 'n2',
    title: 'Hướng dẫn bảo dưỡng pin Lithium đúng cách',
    excerpt: 'Pin là trái tim của xe điện — bảo dưỡng đúng giúp pin bền gấp đôi…',
    image: 'https://images.unsplash.com/photo-1609630875171-b1321377ee65?w=800&q=80',
    date: '28/10/2026',
    to: '/tin-tuc/bao-duong-pin-lithium',
  },
  {
    id: 'n3',
    title: 'So sánh xe đạp điện vs xe máy điện cho học sinh',
    excerpt: 'Chọn loại nào phù hợp với con bạn? Phân tích chi tiết từ chuyên gia…',
    image: 'https://images.unsplash.com/photo-1571068316344-75bc76f77890?w=800&q=80',
    date: '20/10/2026',
    to: '/tin-tuc/so-sanh-xe-dap-xe-may-dien',
  },
]
